'use strict';

export function icitStickyFilter(element) {
	if (!element) return;

	if (window.innerWidth < 1024) {
		const scrollTrigger = ScrollTrigger.create({
			trigger: element,
			start: 'top top+=20',
			endTrigger: document.querySelector('.archive-cases'),
			end: () => 'bottom top+=' + (element.lastElementChild.getBoundingClientRect().height + 20),
			pin: true,
			markers: false,
			pinSpacing: false,
		});

		window.addEventListener('heightChanged', () => {
			ScrollTrigger.refresh();
		});
	}
}
